import getData from "../Data/data.js";
import Async from "react-async";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


function Org(org){
  let key = 0;
  let workExs = [];
  let designations = '';
  if(org.org.workEx){
      org.org.workEx.forEach(workExPoint => {
      if(workExPoint){      
        workExs.push(<li key={key}>{workExPoint}</li>)
        key++; 
        }
      });
    }
  
  key=0;
  if(org.org.designations){
    org.org.designations.forEach(designation => {
      if(key===0) { designations = designation; key++; }
      else designations = designations + ', ' + designation
    });
  }

  return (<><p>
            <em>{org.org.name} | {designations} | {org.org.duration} </em>
         </p>
         <p>
          {org.org.summary}
         </p>
         <ul>
           {workExs}
         </ul>
         </>
         );
}

function Orgs(data){
  let orgs = [];  
  data.data.forEach(org => {orgs.push(<Org org={org} key={org.name}/>)})
  return orgs;
}

function WorkExperiencePoints(){
  return (
  <Async promiseFn={getData} endpoint={'orgs'}> 
  {({ data, error, isPending }) => {
    if (isPending) return (<><h1><Skeleton /></h1><Skeleton count={10}/></>);
    if (error) return `Something went wrong: ${error.message}`
    if (data)  return <Orgs data={data}/>
    return null
  }}
</Async> );
}
function WorkExperience(){
  return (
    <section>
      <h1>Work Experience</h1>
      <hr></hr>
        <WorkExperiencePoints />
    </section>
  );       
}

export default WorkExperience;